/* eslint camelcase: 0 */
import moment from 'moment'
import { MonitaroGatewayBase } from './base'
import { toDoctorProps } from './translator/doctor'
import { toQuery, toQueryProps } from './translator/query'
import { toAppointmentProps } from './translator/appointment'
import { EmptyResponsePropsFactory } from '@/entities/Response'
import { IQueryProps } from '@/entities/Query'
import { FetchDoctor, GetDoctor, GetDoctorAppointment, GetDoctorCalendarEvents } from '@/infrastructure/network/Monitaro/requests/doctor'

export default class Doctor extends MonitaroGatewayBase {
  async FetchDoctor(query?: IQueryProps) {
    const response = await this.apiClient.request(new FetchDoctor(toQuery(query)))
    return EmptyResponsePropsFactory({
      items: response.doctors.map((prop) => toDoctorProps(prop)),
      query: toQueryProps(response.query)
    })
  }

  async GetDoctor(id: string) {
    const { doctor } = await this.apiClient.request(new GetDoctor(id))
    return toDoctorProps(doctor)
  }

  async GetDoctorAppointment(doctor: string, date: string) {
    const { appointments } = await this.apiClient.request(new GetDoctorAppointment(doctor, date))
    return appointments.map(toAppointmentProps)
  }

  async GetDoctorCalendarEvents(doctor: string, date: string) {
    const started = moment(date).startOf('day').toISOString(true)
    const ended = moment(date).endOf('day').toISOString(true)
    const { events } = await this.apiClient.request(new GetDoctorCalendarEvents(doctor, started, ended))
    return events.map((e) => ({ startedAt: e.start, endedAt: e.end }))
  }

  async GetDoctorCalendarEventsForMonth(doctor: string, yearMonth: string) {
    const started = moment(yearMonth).startOf('month').toISOString(true)
    const ended = moment(yearMonth).endOf('month').toISOString(true)
    const { events } = await this.apiClient.request(new GetDoctorCalendarEvents(doctor, started, ended))
    return events.map((e) => ({ startedAt: e.start, endedAt: e.end }))
  }
}
